import { useMutation, useQuery } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';
import { QueryParams } from '@/model';
import { NotificationService } from '../instances/notification-push';
import { CreateNotificationPayload } from '../request/notification-push';

export const useNotifications = (params?: QueryParams) => {
  const query = useQuery(
    ['GET_NOTIFICATIONS', params],
    async () => {
      const [err, data] = await NotificationService.getNotifications(params);
      if (err) {
        throw err;
      }
      return data;
    },
    {
      refetchOnWindowFocus: false,
    },
  );

  const forceRefetch = useCallback(() => {
    query.remove();
    query.refetch();
  }, [query]);

  const returnQuery = useMemo(() => ({ ...query, forceRefetch }), [forceRefetch, query]);

  return returnQuery;
};

export const useCreateNotificationMutation = () => {
  return useMutation({
    mutationKey: ['CREATE_NOTIFICATION'],
    mutationFn: async (payload: CreateNotificationPayload) => {
      const [err, data] = await NotificationService.createNotification(payload);
      if (err) throw err;
      return data;
    },
  });
};
